<template>
  <div class="content-main">
    <!-- Infoauto customer modal -->
    <BaseInfoautoCustomerModal
      @closedCustomer="
        () => {
          iaOpenedCustomer = '';
          syncQuery({
            ia_open: undefined,
            ia_section: undefined,
            quoteTab: undefined
          });
        }
      "
      @editWebCustomer="webOpen"
      :customerId="iaOpenedCustomer"
      :initialSection="
        $route.query.quoteTab || $route.query.ia_section || 'infoauto-data'
      "
      v-model="iaShowCustomerModal"
    />
    <InfoautoCreateCustomerModal
      v-if="iaShowNewCustomerModal"
      @close="iaShowNewCustomerModal = false"
      @newCustomer="
        newCustomer => {
          iaFilters.search = newCustomer.personaId;
          loadIaCustomers();
        }
      "
    />

    <!-- Web customer modal -->
    <BaseCustomerModal
      @closedCustomer="
        () => {
          webOpenedCustomer = '';
          syncQuery({ web_open: undefined });
        }
      "
      @openInfoauto="openInfoautoFromWebCustomer"
      :customerId="webOpenedCustomer"
      v-model="webShowCustomerModal"
    />
    <CreateWebCustomerModal
      v-if="webShowNewCustomerModal"
      v-model="webShowNewCustomerModal"
      @customerCreated="onWebCustomerCreated"
    />

    <div class="content">
      <div class="header">
        <div class="search-row" v-if="activeTab !== 'connect'">
          <input
            type="text"
            v-model="searchInput"
            class="border border-gray rounded-md p-2 search-input"
            :placeholder="
              activeTab === 'infoauto'
                ? $t('message.infoauto_customers_page.search_customers')
                : $t('message.customers_page.search_customers')
            "
          />
        </div>
        <div class="tabs-row">
          <div class="tab-bar">
            <button
              class="tab-btn"
              :class="{ 'tab-btn-active': activeTab === 'infoauto' }"
              @click="switchTab('infoauto')"
            >
              {{ $t("message.infoauto_customers_page.title") }}
            </button>
            <button
              class="tab-btn"
              :class="{ 'tab-btn-active': activeTab === 'web' }"
              @click="switchTab('web')"
            >
              {{ $t("message.customers_page.title") }}
            </button>
            <button
              class="tab-btn"
              :class="{ 'tab-btn-active': activeTab === 'connect' }"
              @click="switchTab('connect')"
            >
              {{ $t("message.infoauto_link.tab") }}
            </button>
          </div>
          <div class="flex items-center gap-2">
            <button
              v-if="activeTab === 'infoauto'"
              class="btn-dark-button"
              @click="iaShowNewCustomerModal = true"
            >
              {{ $t("message.infoauto_customers_page.new_infoauto_customer") }}
            </button>
            <button
              v-if="activeTab === 'web'"
              class="btn-dark-button"
              @click="webShowNewCustomerModal = true"
            >
              + Create Web Customer
            </button>
          </div>
        </div>
      </div>

      <!-- Connect web users to infoauto -->
      <InfoautoLinkSuggestions
        v-if="activeTab === 'connect'"
        @openInfoauto="iaOpen"
        @openWebCustomer="webOpen"
      />

      <!-- Infoauto tab -->
      <template v-if="activeTab === 'infoauto'">
        <div class="table">
          <!-- Desktop table -->
          <table class="default-table desktop-only" v-if="!iaLoading">
            <thead>
              <tr class="table100-head">
                <th
                  v-for="headerItem in iaTableHeaders"
                  :key="headerItem.value"
                  :class="headerItem.align"
                  @click="iaChangeArrowDir(headerItem.value)"
                >
                  {{ headerItem.displayText }}
                  <span v-if="iaFilters.orderCol == headerItem.value">
                    <img
                      :src="
                        require(`@/assets/icons/${iaArrowDirection}-arrow.svg`)
                      "
                    />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="customer in iaCustomers"
                :key="customer.personaId"
                @click="iaOpen(customer.personaId)"
                :class="{ selected: iaSelectedCustomer == customer.personaId }"
              >
                <td class="text-left col-email">{{ customer.email1 }}</td>
                <td class="text-left">{{ customer.nombre }}</td>
                <td class="text-left" style="max-width: 80px">
                  {{ customer.apellidos }}
                </td>
                <td class="text-left">{{ customer.nombreComp }}</td>
                <td class="text-center">{{ customer.phone }}</td>
                <td class="text-center">{{ customer.grupoPrecio }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Mobile/tablet cards -->
          <div class="card-grid mobile-only" v-if="!iaLoading">
            <div
              class="customer-card"
              v-for="customer in iaCustomers"
              :key="customer.personaId"
              @click="iaOpen(customer.personaId)"
            >
              <div class="card-name">
                {{ customer.nombre }} {{ customer.apellidos }}
              </div>
              <div class="card-row" v-if="customer.nombreComp">
                <span class="card-label">{{
                  $t("message.customers_page.company")
                }}</span>
                <span>{{ customer.nombreComp }}</span>
              </div>
              <div class="card-row">
                <span class="card-label">{{
                  $t("message.customers_page.email")
                }}</span>
                <span class="card-email">{{ customer.email1 }}</span>
              </div>
              <div class="card-row" v-if="customer.phone">
                <span class="card-label">{{
                  $t("message.customers_page.phone")
                }}</span>
                <span>{{ customer.phone }}</span>
              </div>
              <div class="card-badge" v-if="customer.grupoPrecio">
                {{ customer.grupoPrecio }}
              </div>
            </div>
          </div>
          <div v-if="iaLoading">{{ $t("message.customers_page.loading") }}</div>
        </div>
        <div class="footer">
          <div class="totals">
            showing
            {{ iaFilters.limitPerPage * (iaFilters.page - 1) }} to
            {{ iaToQuantity() }} from {{ iaTotalItems }} results
          </div>
          <div class="pages">
            <select
              v-model="iaCustomersByPage"
              @change="
                (iaFilters.limitPerPage = iaCustomersByPage),
                  (iaFilters.page = 1)
              "
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
            Per Page
          </div>
          <div class="pages">
            <div>
              <a
                :class="{ disabled: iaFilters.page <= 1 }"
                class="page-link"
                @click="iaPrevious()"
                >Previous</a
              >
            </div>
            <div>Page {{ iaFilters.page }}</div>
            <div>
              <a
                :class="{
                  disabled:
                    iaTotalItems < iaFilters.limitPerPage * iaFilters.page
                }"
                class="page-link"
                @click="iaNext()"
                >Next</a
              >
            </div>
          </div>
        </div>
      </template>

      <!-- Web customers tab -->
      <template v-else-if="activeTab === 'web'">
        <div class="table">
          <!-- Desktop table -->
          <table class="default-table desktop-only" v-if="!webLoading">
            <thead>
              <tr class="table100-head">
                <th
                  v-for="headerItem in webTableHeaders"
                  :key="headerItem.value"
                  :class="headerItem.align"
                  @click="webChangeArrowDir(headerItem.value)"
                >
                  {{ headerItem.displayText }}
                  <span v-if="webFilters.orderCol == headerItem.value">
                    <img
                      :src="
                        require(`@/assets/icons/${webArrowDirection}-arrow.svg`)
                      "
                    />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="customer in webCustomers"
                :key="customer.id"
                @click="webOpen(customer.id)"
                :class="{ selected: webSelectedCustomer == customer.id }"
              >
                <td class="text-left col-email">{{ customer.email }}</td>
                <td class="text-left">{{ customer.name }}</td>
                <td class="text-left" style="max-width: 80px">
                  {{ customer.surname }}
                </td>
                <td class="text-left">{{ customer.companyName }}</td>
                <td class="text-center">{{ customer.phone }}</td>
                <td class="text-center">{{ customer.priceLevel }}</td>
              </tr>
            </tbody>
          </table>
          <!-- Mobile/tablet cards -->
          <div class="card-grid mobile-only" v-if="!webLoading">
            <div
              class="customer-card"
              v-for="customer in webCustomers"
              :key="customer.id"
              @click="webOpen(customer.id)"
            >
              <div class="card-name">
                {{ customer.name }} {{ customer.surname }}
              </div>
              <div class="card-row" v-if="customer.companyName">
                <span class="card-label">{{
                  $t("message.customers_page.company")
                }}</span>
                <span>{{ customer.companyName }}</span>
              </div>
              <div class="card-row">
                <span class="card-label">{{
                  $t("message.customers_page.email")
                }}</span>
                <span class="card-email">{{ customer.email }}</span>
              </div>
              <div class="card-row" v-if="customer.phone">
                <span class="card-label">{{
                  $t("message.customers_page.phone")
                }}</span>
                <span>{{ customer.phone }}</span>
              </div>
              <div class="card-badge" v-if="customer.priceLevel">
                {{ customer.priceLevel }}
              </div>
            </div>
          </div>
          <div v-if="webLoading">
            {{ $t("message.customers_page.loading") }}
          </div>
        </div>
        <div class="footer">
          <div class="totals">
            {{ $t("message.customers_page.showing") }}
            {{ webFilters.limitPerPage * (webFilters.page - 1) }}
            {{ $t("message.customers_page.to") }} {{ webToQuantity() }}
            {{ $t("message.customers_page.from") }} {{ webTotalItems }}
            {{ $t("message.customers_page.results") }}
          </div>
          <div class="pages">
            <select
              v-model="webCustomersByPage"
              @change="
                (webFilters.limitPerPage = webCustomersByPage),
                  (webFilters.page = 1)
              "
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
            {{ $t("message.customers_page.per_page") }}
          </div>
          <div class="pages">
            <div>
              <a
                :class="{ disabled: webFilters.page <= 1 }"
                class="page-link"
                @click="webPrevious()"
                >Previous</a
              >
            </div>
            <div>Page {{ webFilters.page }}</div>
            <div>
              <a
                :class="{
                  disabled:
                    webTotalItems < webFilters.limitPerPage * webFilters.page
                }"
                class="page-link"
                @click="webNext()"
                >Next</a
              >
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { infoautoSearchCustomer } from "@/api/store/Infoauto.js";
import { getCustomers } from "@/api/store/CustomersService.js";
import InfoautoCreateCustomerModal from "@/components/customer/InfoautoCreateCustomerModal.vue";
import CreateWebCustomerModal from "@/components/customer/CreateWebCustomerModal.vue";
import InfoautoLinkSuggestions from "@/components/customer/InfoautoLinkSuggestions.vue";

export default {
  name: "CustomersPage",
  components: {
    InfoautoCreateCustomerModal,
    CreateWebCustomerModal,
    InfoautoLinkSuggestions
  },
  data() {
    return {
      activeTab: "infoauto",
      searchInput: "",

      // --- Infoauto tab state ---
      iaFilters: {
        page: 1,
        limitPerPage: 10,
        orderCol: "name",
        orderDir: "desc",
        search: "",
        statusShipment: ""
      },
      iaCustomersByPage: 10,
      iaCustomers: [],
      iaTotalItems: 0,
      iaTotalPages: 0,
      iaLoading: false,
      iaSelectedCustomer: null,
      iaOpenedCustomer: "",
      iaShowCustomerModal: false,
      iaShowNewCustomerModal: false,

      // --- Web tab state ---
      webFilters: {
        page: 1,
        limitPerPage: 100,
        orderCol: "name",
        orderDir: "desc",
        search: "",
        statusShipment: ""
      },
      webCustomersByPage: 100,
      webCustomers: [],
      webTotalItems: 0,
      webTotalPages: 0,
      webLoading: false,
      webLoaded: false,
      webSelectedCustomer: null,
      webOpenedCustomer: "",
      webShowCustomerModal: false,
      webShowNewCustomerModal: false
    };
  },
  watch: {
    searchInput(val) {
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => {
        this.updateSearchFilter(val);
      }, 300);
    },
    "$route.query": {
      deep: true,
      handler(query) {
        if (query.tab && query.tab !== this.activeTab) {
          this.activeTab = query.tab;
          if (query.tab === "web" && !this.webLoaded) {
            this.loadWebCustomers();
          }
        }
        if (typeof query.search === "string") {
          this.searchInput = query.search;
          this.iaFilters.search = query.search;
          this.webFilters.search = query.search;
        }
        if (query.ia_open && this.iaOpenedCustomer !== query.ia_open) {
          this.iaOpen(query.ia_open, true);
        }
        if (query.web_open && this.webOpenedCustomer !== query.web_open) {
          this.webOpen(query.web_open);
        }
      }
    },
    iaFilters: {
      deep: true,
      handler() {
        if (!this.iaLoading) {
          this.loadIaCustomers();
        }
      }
    },
    webFilters: {
      deep: true,
      handler() {
        if (!this.webLoading) {
          this.loadWebCustomers();
        }
      }
    }
  },
  computed: {
    activeFilters() {
      return this.activeTab === "infoauto" ? this.iaFilters : this.webFilters;
    },
    iaTableHeaders() {
      return [
        {
          displayText: this.$t("message.customers_page.email"),
          value: "email",
          align: "text-left col-email"
        },
        {
          displayText: this.$t("message.customers_page.name"),
          value: "name",
          align: "text-left"
        },
        {
          displayText: this.$t("message.customers_page.surname"),
          value: "surname",
          align: "text-left"
        },
        {
          displayText: this.$t("message.customers_page.company"),
          value: "company",
          align: "text-left"
        },
        {
          displayText: this.$t("message.customers_page.phone"),
          value: "phone",
          align: "text-center"
        },
        {
          displayText: this.$t("message.customers_page.price_level"),
          value: "price_level",
          align: "text-center"
        }
      ];
    },
    iaArrowDirection() {
      return this.iaFilters.orderDir === "desc" ? "down" : "up";
    },
    webTableHeaders() {
      return [
        {
          displayText: this.$t("message.customers_page.email"),
          value: "email",
          align: "text-left col-email"
        },
        {
          displayText: this.$t("message.customers_page.name"),
          value: "name",
          align: "text-left"
        },
        {
          displayText: this.$t("message.customers_page.surname"),
          value: "surname",
          align: "text-left"
        },
        {
          displayText: this.$t("message.customers_page.company"),
          value: "company",
          align: "text-left"
        },
        {
          displayText: this.$t("message.customers_page.phone"),
          value: "phone",
          align: "text-center"
        },
        {
          displayText: this.$t("message.customers_page.price_level"),
          value: "price_level",
          align: "text-center"
        }
      ];
    },
    webArrowDirection() {
      return this.webFilters.orderDir === "desc" ? "down" : "up";
    }
  },
  mounted() {
    const q = this.$route.query;
    const tab = q.tab;
    if (tab === "web" || tab === "infoauto" || tab === "connect") {
      this.activeTab = tab;
    }
    if (q.search) {
      this.searchInput = q.search;
      this.iaFilters.search = q.search;
      this.webFilters.search = q.search;
    }
    this.loadIaCustomers();
    if (this.activeTab === "web") {
      this.loadWebCustomers();
    }
    if (q.ia_open) {
      this.$nextTick(() => this.iaOpen(q.ia_open, true));
    }
    if (q.web_open) {
      this.$nextTick(() => this.webOpen(q.web_open));
    }
  },
  methods: {
    switchTab(tab) {
      this.activeTab = tab;
      this.$router
        .replace({ query: { ...this.$route.query, tab } })
        .catch(() => {});
      if (tab === "web" && !this.webLoaded) {
        this.loadWebCustomers();
      }
    },
    syncQuery(patch) {
      this.$router
        .replace({ query: { ...this.$route.query, ...patch } })
        .catch(() => {});
    },
    openInfoautoFromWebCustomer(infoautoId) {
      this.webShowCustomerModal = false;
      this.iaOpen(infoautoId);
    },
    onWebCustomerCreated() {
      this.loadWebCustomers();
    },
    updateSearchFilter(search) {
      if (this.activeTab === "infoauto") {
        if (this.iaFilters.search === search) return;
        this.iaFilters.page = 1;
        this.iaFilters.search = search;
        this.syncQuery({ search: search || undefined });
      } else {
        if (this.webFilters.search === search) return;
        this.webFilters.page = 1;
        this.webFilters.search = search;
        this.syncQuery({ search: search || undefined });
      }
    },

    // --- Infoauto methods ---
    async loadIaCustomers() {
      if (!this.iaFilters.search) {
        this.iaCustomers = [];
        this.iaTotalItems = 0;
        this.iaLoading = false;
        return;
      }
      this.iaLoading = true;
      const res = await infoautoSearchCustomer(
        this.iaFilters.search,
        null,
        this.iaFilters.page,
        this.iaFilters.limitPerPage,
        this.iaFilters.orderCol,
        this.iaFilters.orderDir
      ).catch(() => {
        this.$toast.open({
          message: "Error getting customers",
          type: "error",
          position: "top-right"
        });
      });
      if (res && res.data) {
        this.iaCustomers = res.data;
        this.iaTotalItems = res.totalItems;
        this.iaTotalPages = res.paginaUlt;
      }
      this.iaLoading = false;
    },
    iaOpen(customerID, keepRouteContext = false) {
      this.iaOpenedCustomer = customerID;
      this.iaShowCustomerModal = true;
      if (keepRouteContext) {
        this.syncQuery({
          ia_open: customerID || undefined,
          ia_section: this.$route.query.ia_section || undefined,
          quoteTab: this.$route.query.quoteTab || undefined
        });
      } else {
        this.syncQuery({
          ia_open: customerID || undefined,
          ia_section: undefined,
          quoteTab: undefined
        });
      }
    },
    iaPrevious() {
      if (this.iaFilters.page > 1) this.iaFilters.page--;
    },
    iaNext() {
      if (
        this.iaTotalItems >=
        this.iaFilters.limitPerPage * this.iaFilters.page
      ) {
        this.iaFilters.page++;
      }
    },
    iaToQuantity() {
      return (
        this.iaFilters.limitPerPage * (this.iaFilters.page - 1) +
        this.iaCustomers.length
      );
    },
    iaChangeArrowDir(headerValue) {
      this.iaFilters.page = 1;
      if (headerValue === this.iaFilters.orderCol) {
        this.iaFilters.orderDir =
          this.iaFilters.orderDir === "desc" ? "asc" : "desc";
      } else {
        this.iaFilters.orderCol = headerValue;
        this.iaFilters.orderDir = "desc";
      }
    },

    // --- Web customer methods ---
    async loadWebCustomers() {
      if (!this.webFilters.search) {
        this.webCustomers = [];
        this.webTotalItems = 0;
        this.webLoading = false;
        return;
      }
      this.webLoading = true;
      const res = await getCustomers(this.webFilters).catch(() => {
        this.$toast.open({
          message: "Error getting web customers",
          type: "error",
          position: "top-right"
        });
      });
      if (res && res.customers) {
        this.webCustomers = res.customers;
        this.webTotalItems = res.totalItems;
        this.webTotalPages = res.totalPages;
      }
      this.webLoading = false;
      this.webLoaded = true;
    },
    webOpen(customerID, customer) {
      this.webOpenedCustomer = customerID;
      this.webShowCustomerModal = true;

      if (customer && customer.email) {
        this.activeTab = "web";
        this.searchInput = customer.email;
        this.webFilters.page = 1;
        this.webFilters.search = customer.email;
        if (!this.webLoaded) {
          this.loadWebCustomers();
        }
        this.syncQuery({
          tab: "web",
          search: customer.email,
          web_open: customerID || undefined
        });
      } else {
        this.syncQuery({ web_open: customerID || undefined });
      }
    },
    webPrevious() {
      if (this.webFilters.page > 1) this.webFilters.page--;
    },
    webNext() {
      if (
        this.webTotalItems >=
        this.webFilters.limitPerPage * this.webFilters.page
      ) {
        this.webFilters.page++;
      }
    },
    webToQuantity() {
      return (
        this.webFilters.limitPerPage * (this.webFilters.page - 1) +
        this.webCustomers.length
      );
    },
    webChangeArrowDir(headerValue) {
      this.webFilters.page = 1;
      if (headerValue === this.webFilters.orderCol) {
        this.webFilters.orderDir =
          this.webFilters.orderDir === "desc" ? "asc" : "desc";
      } else {
        this.webFilters.orderCol = headerValue;
        this.webFilters.orderDir = "desc";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.content-main {
  flex-direction: column !important;

  .content {
    padding: 5px;
    width: 100%;

    .header {
      width: 100%;
      padding: 8px 15px 0;
      display: flex;
      flex-direction: column;
      gap: 4px;

      .search-row {
        display: flex;
      }

      .tabs-row {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 6px;

        @media (max-width: 600px) {
          .tab-bar {
            order: 1;
          }
          .flex {
            order: 2;
            width: 100%;
          }
          button {
            width: 100%;
          }
        }
      }
    }

    .tab-bar {
      display: flex;
      gap: 4px;
      flex-shrink: 0;
      max-width: 100%;
      overflow-x: auto;
    }

    .tab-btn {
      padding: 8px 20px;
      border: none;
      border-bottom: 3px solid transparent;
      background: transparent;
      cursor: pointer;
      font-size: 0.95rem;
      font-weight: 500;
      color: #6b7280;
      transition: color 0.15s, border-color 0.15s;
      white-space: nowrap;

      &:hover {
        color: #374151;
      }

      &.tab-btn-active {
        color: #1d4ed8;
        border-bottom-color: #1d4ed8;
        font-weight: 600;
      }
    }

    .search-input {
      width: 100%;
    }

    .table {
      width: 100%;
      height: calc(100% - 200px);
      overflow-x: auto;

      th.text-left {
        text-align: left;
      }
      th.text-center {
        text-align: center;
      }
      td.text-left {
        text-align: left;
      }
      td.text-center {
        text-align: center;
      }
      th.col-email,
      td.col-email {
        max-width: 260px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .desktop-only {
        display: table;
      }
      .mobile-only {
        display: none;
      }

      @media (max-width: 1024px) {
        .desktop-only {
          display: none;
        }
        .mobile-only {
          display: grid;
        }
      }
    }

    .card-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      padding: 12px;

      @media (max-width: 600px) {
        grid-template-columns: 1fr;
      }
    }

    .customer-card {
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      padding: 12px 14px;
      cursor: pointer;
      position: relative;
      transition: box-shadow 0.15s, border-color 0.15s;

      &:hover {
        border-color: #93c5fd;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
      }

      .card-name {
        font-weight: 600;
        font-size: 15px;
        margin-bottom: 6px;
        color: #111827;
      }

      .card-row {
        display: flex;
        gap: 6px;
        font-size: 13px;
        color: #374151;
        margin-bottom: 3px;
        align-items: baseline;
      }

      .card-label {
        font-weight: 500;
        color: #6b7280;
        white-space: nowrap;
        flex-shrink: 0;

        &::after {
          content: ":";
        }
      }

      .card-email {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .card-badge {
        display: inline-block;
        margin-top: 8px;
        padding: 2px 8px;
        background: #eff6ff;
        color: #1d4ed8;
        border-radius: 999px;
        font-size: 12px;
        font-weight: 600;
      }
    }

    .footer {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 6px;
      padding: 6px 4px;

      .totals {
        font-size: 13px;
        color: #6b7280;
      }

      .pages {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;

        div {
          width: auto;
          min-width: 60px;
          text-align: center;
        }

        select {
          padding: 2px 4px;
        }
      }

      @media (max-width: 600px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .page-link {
        color: $link-color-1;
        cursor: pointer;
      }
    }
  }
}
</style>
